import { RadioGroup } from '@mui/material';

import { LabeledRadio } from '../../generic/Forms';
import type { AuthContextState } from '../context/AuthContext';

type AuthFormOrgPickerProps = Pick<
  AuthContextState,
  'organizations' | 'selectedOrgId' | 'onSelectOrg'
>;

const AuthFormOrgPicker = ({
  organizations,
  selectedOrgId,
  onSelectOrg,
}: AuthFormOrgPickerProps) => (
  <fieldset className="fossa-auth__form__org-picker">
    <legend className="fossa-auth__form__org-picker__legend">
      You have access to multiple organizations. Choose one to continue:
    </legend>
    <RadioGroup
      name="login-org-picker"
      value={selectedOrgId == null ? '' : String(selectedOrgId)}
      onChange={(_event, value) => onSelectOrg(Number(value))}
    >
      {organizations.map(org => (
        <LabeledRadio
          key={org.id}
          value={String(org.id)}
          label={org.title}
        />
      ))}
    </RadioGroup>
  </fieldset>
);

export default AuthFormOrgPicker;
